import axios from "axios";  // plain axios, NOT apiClient
import { getFingerprint } from "./fingerPrintService";

const baseAPIUrl = process.env.REACT_APP_API_URL + "/api";

export const requestNonce = async () => {
  const fingerprint = getFingerprint();

  // Use plain axios here to avoid triggering apiClient interceptors
  const response = await axios.post<{ nonce: string }>(
    `${baseAPIUrl}/nonce/request`,
    { fingerprint },
    { headers: { "Content-Type": "application/json" } }
  );

  return {
    nonce: response.data.nonce,
    fingerprint
  };
};